<template>
  <nav class="navbar" :class="{ 'is-scrolled': isScrolled }" id="app-navbar">
    <div class="navbar-container">
      <router-link to="/" class="navbar-logo" id="nav-logo-link">
        <img :src="siteConfig.logoUrl || require('@/assets/logo.jpg')" alt="Logo" class="logo-img">
        <span class="logo-text">{{ siteConfig.siteName || '简研AI一页纸报告' }}</span>
      </router-link>

      <div class="navbar-menu" :class="{ 'is-active': isMenuOpen }">
        <router-link to="/" exact class="nav-item" id="nav-home-link" @click.native="closeMenu">
          首页
        </router-link>

        <router-link v-if="user" to="/pricing" class="nav-item" id="nav-pricing-link" @click.native="closeMenu">
          价格套餐
        </router-link>
        <router-link to="/enterprise" class="nav-item" id="nav-enterprise-link" @click.native="closeMenu">
          企业服务
        </router-link>
        <router-link to="/about" class="nav-item" id="nav-about-link" @click.native="closeMenu">
          关于我们
        </router-link>

        <router-link v-if="user" to="/my" class="nav-item" @click.native="closeMenu">我的</router-link>
        <router-link v-else to="/login" class="nav-item" @click.native="closeMenu">登录</router-link>
      </div>

      <button class="menu-toggle" :class="{ 'is-active': isMenuOpen }" id="nav-menu-toggle" @click="toggleMenu" aria-label="Toggle menu">
        <span class="toggle-bar"></span>
        <span class="toggle-bar"></span>
        <span class="toggle-bar"></span>
      </button>
    </div>

  </nav>
</template>

<script>
import { mapState } from 'vuex'
import { getUser } from '@/utils/auth'

export default {
  name: 'AppNavbar',
  data() {
    return {
      isMenuOpen: false,
      showQrModal: false,
      isScrolled: false
    }
  },
  computed: {
    ...mapState(['siteConfig']),
    user() {
      const route = this.$route.fullPath
      return route ? getUser() : null
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
    this.$root.$on('show-qr-modal', this.openQrModal)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    this.$root.$off('show-qr-modal', this.openQrModal)
  },
  methods: {
    openQrModal() {
      this.showQrModal = true
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 20
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 110px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: var(--glass-blur);
  -webkit-backdrop-filter: var(--glass-blur);
  border-bottom: var(--border-subtle);
  z-index: 1000;
  display: flex;
  align-items: center;
  transition: var(--transition-normal);
}

/* Scrolled visual state styling */
.navbar.is-scrolled {
  height: 80px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 30px rgba(37, 99, 235, 0.04);
  border-bottom-color: rgba(37, 99, 235, 0.15);
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 2rem;
}

.navbar-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.03em;
  transition: var(--transition-fast);
}
.navbar-logo:hover {
  text-shadow: 0 0 10px rgba(37, 99, 235, 0.3);
}

.logo-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  color: var(--accent-primary);
  filter: drop-shadow(0 0 4px rgba(37, 99, 235, 0.25));
}

.logo-img {
  width: 6.4rem;
  height: 6.4rem;
  object-fit: contain;
  border-radius: 4px;
  transition: var(--transition-normal);
}

.navbar.is-scrolled .logo-img {
  width: 4.5rem;
  height: 4.5rem;
}

.logo-badge {
  font-size: 0.65rem;
  font-weight: 600;
  background: var(--grad-hero);
  color: var(--text-light);
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 0.35rem;
  box-shadow: 0 0 8px rgba(37, 99, 235, 0.2);
}

.navbar-menu {
  display: flex;
  align-items: center;
  gap: 1.75rem;
}

.nav-item {
  color: var(--text-secondary);
  font-family: var(--font-display);
  font-weight: 500;
  font-size: 0.95rem;
  position: relative;
  padding: 0.35rem 0;
  transition: var(--transition-fast);
}

.nav-item:hover, .router-link-active.nav-item {
  color: var(--accent-primary);
  text-shadow: 0 0 8px rgba(37, 99, 235, 0.1);
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--grad-hero);
  transition: var(--transition-normal);
}

.nav-item:hover::after, .router-link-active.nav-item::after {
  width: 100%;
}

.nav-cta-btn {
  font-size: 0.85rem;
  padding: 0.55rem 1.35rem;
  border-radius: var(--border-radius-xs);
}

.nav-cta-btn .arrow {
  transition: var(--transition-fast);
}

.nav-cta-btn:hover .arrow {
  transform: translateX(4px);
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1001;
}

.toggle-bar {
  width: 100%;
  height: 2px;
  background: var(--text-primary);
  border-radius: 2px;
  transition: var(--transition-normal);
  transform-origin: center;
}

.menu-toggle.is-active .toggle-bar:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
  background: var(--accent-primary);
}

.menu-toggle.is-active .toggle-bar:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.menu-toggle.is-active .toggle-bar:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
  background: var(--accent-primary);
}

/* QR code modal styles */
.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  transition: var(--transition-normal);
}

.qr-modal-content {
  position: relative;
  width: 90%;
  max-width: 420px;
  text-align: center;
  padding: 3rem 2rem 2.5rem;
  border: var(--border-subtle);
  box-shadow: var(--shadow-xl), var(--shadow-glow);
  background: var(--bg-secondary);
  transform: scale(0.95);
  opacity: 0;
  animation: modalScaleIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes modalScaleIn {
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-close {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: 1.5rem;
  cursor: pointer;
  transition: var(--transition-fast);
}

.modal-close:hover {
  color: var(--accent-primary);
}

.qr-modal-content h3 {
  margin-bottom: 0.75rem;
  font-size: 1.35rem;
  color: var(--text-primary);
}

.modal-desc {
  font-size: 0.85rem;
  margin-bottom: 2rem;
  color: var(--text-secondary);
}

.qr-code-placeholder {
  width: 190px;
  height: 190px;
  margin: 0 auto 1.5rem;
  background: var(--bg-primary);
  border: 1px solid rgba(37, 99, 235, 0.15);
  border-radius: var(--border-radius-md);
  padding: 12px;
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.05);
}

.qr-code-mock {
  width: 100%;
  height: 100%;
  background:
    radial-gradient(rgba(37, 99, 235, 0.15) 1.5px, transparent 1.5px) 0 0/12px 12px,
    repeating-linear-gradient(rgba(37, 99, 235, 0.05) 0 1px, transparent 1px 12px);
  border-radius: var(--border-radius-sm);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  background: var(--bg-secondary);
  border-radius: var(--border-radius-sm);
  border: 1px solid rgba(37, 99, 235, 0.2);
  box-shadow: 0 0 15px rgba(37, 99, 235, 0.12);
  z-index: 2;
  color: var(--accent-primary);
}

.qr-corners {
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  bottom: 8px;
  border: 2px dashed rgba(37, 99, 235, 0.3);
  border-radius: var(--border-radius-sm);
  pointer-events: none;
}

.qr-scan-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--grad-hero);
  box-shadow: 0 0 12px rgba(37, 99, 235, 0.8);
  animation: scan 3s ease-in-out infinite;
  z-index: 1;
}

@keyframes scan {
  0% { top: 0; }
  50% { top: 100%; }
  100% { top: 0; }
}

.qr-tip {
  font-size: 0.75rem;
  color: var(--text-muted);
  letter-spacing: 3px;
  font-weight: 600;
  text-transform: uppercase;
}

@media (max-width: 992px) {
  .navbar-menu {
    gap: 1.25rem;
  }
  .nav-item {
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .menu-toggle {
    display: flex;
  }

  .navbar-menu {
    position: fixed;
    top: 76px;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: var(--border-subtle);
    padding: 2.5rem 2rem;
    flex-direction: column;
    gap: 1.5rem;
    transform: translateY(-15px);
    opacity: 0;
    visibility: hidden;
    transition: var(--transition-normal);
    z-index: 999;
  }

  .navbar.is-scrolled .navbar-menu {
    top: 64px;
  }

  .navbar-menu.is-active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-action {
    width: 100%;
    margin-top: 1rem;
  }

  .nav-cta-btn {
    width: 100%;
    padding: 0.8rem;
  }
}
</style>
